import React, { useState, useEffect, useRef } from 'react';
import { initializeApp } from 'firebase/app';
import { getAuth, signInAnonymously, signInWithCustomToken, onAuthStateChanged } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

import AuthScreen from './screens/AuthScreen';
import PuzzleSelectionScreen from './screens/PuzzleSelectionScreen';
import PuzzlePreviewScreen from './screens/PuzzlePreviewScreen';
import DifficultySelectionScreen from './screens/DifficultySelectionScreen';
import PuzzleGameScreen from './screens/PuzzleGameScreen';
import ResultScreen from './screens/ResultScreen';
import LeaderboardScreen from './screens/LeaderboardScreen';

import Puzzle1 from './assets/Advaith3.jpg';
import Puzzle2 from './assets/Enspire.jpg';
import Puzzle3 from './assets/stepakks.jpg';
import Puzzle4 from './assets/Yinger2.png';
import Puzzle5 from './assets/coco.jpg';
import Puzzle6 from './assets/zkdan.jpg';
import Puzzle7 from './assets/olu.jpg';
import Puzzle8 from './assets/zarhon.jpg';
import Puzzle9 from './assets/saigon.jpg';
import Puzzle10 from './assets/cryptomeii.jpg';
import Puzzle11 from './assets/Wylo.jpg';
import Puzzle12 from './assets/ljn.jpg';
import Puzzle13 from './assets/jekyde.jpg';
import Puzzle14 from './assets/shalen.jpg';
import Puzzle15 from './assets/serkenals.jpg';
import Puzzle16 from './assets/pix.jpg';
import Puzzle17 from './assets/imani.jpg';
import Puzzle18 from './assets/joe.jpg';
import Puzzle19 from './assets/joh.jpg';
import Puzzle20 from './assets/makise.jpg';

import puzzleMusic from './assets/puzzle.mp3'; // make sure this path is correct

export const formatTime = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes} min ${remainingSeconds < 10 ? '0' : ''}${remainingSeconds} sec`;
};

const puzzles = [
  { id: 'stepaks', name: 'Stepaks', imageUrl: Puzzle3, personalityDetails: 'Badass Dev, Supporter and Monster Drinker' },
  { id: 'yinger', name: 'Yinger', imageUrl: Puzzle4, personalityDetails: 'Banger Guy and He who has nothing to lose can afford all risks.' },
  { id: 'addy', name: 'Addy', imageUrl: Puzzle1, personalityDetails: 'Badass Dev and Head of Shitposting' },
  { id: 'zarh0n', name: 'Zarh0n_', imageUrl: Puzzle8, personalityDetails: 'Succinct Investigator and The Meow Guy' },
  { id: 'enspire', name: 'Enspire', imageUrl: Puzzle2, personalityDetails: 'Tech Creativity and Contibutor' },
  { id: 'coco', name: 'ＣＯＣＯ ＷＡＶΞＳ', imageUrl: Puzzle5, personalityDetails: 'Preacher of ZK and Professional Writer' },
  { id: 'zkdan', name: 'zkDan', imageUrl: Puzzle6, personalityDetails: 'Sr. Troll, Marketer, Beer and Cigarette' },
  { id: 'oluseyi', name: 'Oluseyix', imageUrl: Puzzle7, personalityDetails: 'The Grinder and Supporter' },
  { id: 'saigon', name: 'Saigon', imageUrl: Puzzle9, personalityDetails: 'Cat Lover and Community Lover and Helper' },
  { id: 'cryptomeii', name: 'CryptoMeii', imageUrl: Puzzle10, personalityDetails: 'Corporate Guy and Community helper' },
  { id: 'wylo', name: 'Wylo', imageUrl: Puzzle11, personalityDetails: 'Friend of Addy and Clown' },
  { id: 'ljngljng', name: 'LjngLjng', imageUrl: Puzzle12, personalityDetails: 'Unique Artist and Amazing Contributor' },
  { id: 'jekyde', name: 'Jekyde', imageUrl: Puzzle13, personalityDetails: 'Resilient and Passionate' },
  { id: 'shalen', name: 'Shalen', imageUrl: Puzzle14, personalityDetails: 'Study Shalen And Supporter' },
  { id: 'serkanels', name: 'serkan', imageUrl: Puzzle15, personalityDetails: 'Unwavering and Delivering' },
  { id: 'pix', name: 'Pix', imageUrl: Puzzle16, personalityDetails: 'A True Lover and Supporter' },
  { id: 'imani', name: 'Imani', imageUrl: Puzzle17, personalityDetails: 'Passionate and Creative' },
  { id: 'joesofth3art', name: 'joesofth3art.ai.eth', imageUrl: Puzzle18, personalityDetails: 'Banger Artist and Ape Guy' },
  { id: 'joh', name: 'Joh', imageUrl: Puzzle19, personalityDetails: 'Cat Guy and Fatanstic Artist' },
  { id: 'makise', name: 'makise ∮', imageUrl: Puzzle20, personalityDetails: 'Believe and Love everything meow' },
];

const firebaseConfig = {
  apiKey: "AIzaSyB12W6dNRj4J434x3fh2pUhNQd_yGHUTQI",
  authDomain: "puzzlegame-aae42.firebaseapp.com",
  projectId: "puzzlegame-aae42",
  storageBucket: "puzzlegame-aae42.appspot.com",
  messagingSenderId: "396569439692",
  appId: "1:396569439692:web:dd307977d548892fda0169",
  measurementId: "G-S1SHBYMEEV"
};

const App = () => {
  const [currentScreen, setCurrentScreen] = useState('login');
  const [username, setUsername] = useState('');
  const [userPfp, setUserPfp] = useState('');
  const [userId, setUserId] = useState(null);
  const [selectedPuzzle, setSelectedPuzzle] = useState(null);
  const [selectedDifficulty, setSelectedDifficulty] = useState('');
  const [gameTime, setGameTime] = useState(0);
  const [isGameWon, setIsGameWon] = useState(false);
  const [db, setDb] = useState(null);
  const [auth, setAuth] = useState(null);
  const [isAuthReady, setIsAuthReady] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [isMuted, setIsMuted] = useState(false);
  const audioRef = useRef(null);

  useEffect(() => {
    const app = initializeApp(firebaseConfig);
    const firestore = getFirestore(app);
    const authInstance = getAuth(app);

    setDb(firestore);
    setAuth(authInstance);

    const unsubscribe = onAuthStateChanged(authInstance, async (user) => {
      if (user) {
        setUserId(user.uid);
      } else {
        try {
          await signInAnonymously(authInstance);
          setUserId(authInstance.currentUser?.uid || crypto.randomUUID());
        } catch (error) {
          console.error("Anonymous sign-in failed:", error);
          setErrorMessage("Failed to sign in. Please try again.");
        }
      }
      setIsAuthReady(true);
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.volume = 0.15;
      audioRef.current.loop = true;
      audioRef.current.play().catch(() => {});
    }
  }, [audioRef]);

  const renderScreen = () => {
    if (errorMessage) {
      return (
        <div className="flex flex-col items-center justify-center h-full p-4">
          <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 rounded-md shadow-lg" role="alert">
            <p className="font-bold">Error:</p>
            <p>{errorMessage}</p>
            <button
              onClick={() => {
                setErrorMessage('');
                setCurrentScreen('login');
              }}
              className="mt-4 bg-red-500 text-white py-2 px-4 rounded-lg hover:bg-red-600 transition duration-300"
            >Try Again</button>
          </div>
        </div>
      );
    }

    if (!isAuthReady) {
      return (
        <div className="flex flex-col items-center justify-center h-full p-4">
          <div className="bg-white p-8 rounded-xl shadow-2xl max-w-md w-full text-center border-4 border-pink-500">
            <h2 className="text-3xl font-extrabold mb-6 text-pink-600">Loading Game...</h2>
            <p className="text-gray-700">Please wait...</p>
            <div className="mt-6 flex justify-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-4 border-pink-500"></div>
            </div>
          </div>
        </div>
      );
    }

    switch (currentScreen) {
      case 'login':
        return <AuthScreen setUsername={setUsername} setUserPfp={setUserPfp} setCurrentScreen={setCurrentScreen} setErrorMessage={setErrorMessage} />;
      case 'selectPuzzle':
        return <PuzzleSelectionScreen puzzles={puzzles} setSelectedPuzzle={setSelectedPuzzle} setCurrentScreen={setCurrentScreen} />;
      case 'previewPuzzle':
        return <PuzzlePreviewScreen selectedPuzzle={selectedPuzzle} setCurrentScreen={setCurrentScreen} />;
      case 'selectDifficulty':
        return <DifficultySelectionScreen selectedPuzzle={selectedPuzzle} setSelectedDifficulty={setSelectedDifficulty} setCurrentScreen={setCurrentScreen} />;
      case 'game':
        return <PuzzleGameScreen selectedPuzzle={selectedPuzzle} difficulty={selectedDifficulty} setCurrentScreen={setCurrentScreen} setGameTime={setGameTime} setIsGameWon={setIsGameWon} setErrorMessage={setErrorMessage} />;
      case 'result':
        return <ResultScreen isGameWon={isGameWon} username={username} userPfp={userPfp} selectedPuzzle={selectedPuzzle} difficulty={selectedDifficulty} gameTime={gameTime} setCurrentScreen={setCurrentScreen} db={db} userId={userId} appId="puzzlegame-aae42" isAuthReady={isAuthReady} setErrorMessage={setErrorMessage} />;
      case 'leaderboard':
        return <LeaderboardScreen db={db} appId="puzzlegame-aae42" isAuthReady={isAuthReady} setCurrentScreen={setCurrentScreen} setErrorMessage={setErrorMessage} />;
      default:
        return <AuthScreen setUsername={setUsername} setUserPfp={setUserPfp} setCurrentScreen={setCurrentScreen} setErrorMessage={setErrorMessage} />;
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-100 via-orange-100 to-pink-200 font-inter text-gray-900 flex items-center justify-center p-4 relative">
      <audio ref={audioRef} src={puzzleMusic} autoPlay muted={isMuted} />
      <button
        onClick={() => setIsMuted(!isMuted)}
        className="absolute top-4 right-4 bg-white text-xl p-2 rounded-full shadow-md hover:bg-gray-200 transition"
        title="Toggle Sound"
      >
        {isMuted ? '🔇' : '🔊'}
      </button>
      {renderScreen()}
    </div>
  );
};

export default App;
